import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/sv'
import { getLanguageCode } from '../ygdrasil/libs/useLanguage'
import { Language } from '../ygdrasil/types/Antiloop'

export function loadLocale(language: Language = getLanguageCode()) {
  dayjs.locale(language)
}
